module.exports = __webpack_public_path__ + "img/arrow-down.7c7cc109.svg";